/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/dining-out': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M7.36 13.207l2.83-2.83L4 4.197c-.48-.48-1.31-.35-1.61.27-.71 1.49-.45 3.32.78 4.56l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27l-9.06 9.06a.996.996 0 101.41 1.41l6.19-6.17 6.18 6.18a.996.996 0 101.41-1.41l-6.18-6.18 1.47-1.47z" _fill="#000" fill-rule="evenodd"/>'
  }
})
